import request from 'src/utils/request';
// import { response } from 'express'

export const getUsers = (params: any) =>
  request({
    url: '/users',
    method: 'get',
    params,
  }).then(response => response.data);

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data,
  }).then(response => response.data);

export const getUserByName = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'get',
  }).then(response => response.data);

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: 'put',
    data,
  }).then(response => response.data);

export const deleteUser = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'delete',
  }).then(response => response.data);

export const login = (data: any) => {
  return request
    .post('/auth/token-v2', data)
    .then(response => response);
};

export const onInitOTP = (data: any) => {
  return request
    .post('/auth/otp/init', data)
    .then(response => response);
};

export const onVerifyOTP = (data: any) => {
  return request
    .post('/auth/otp/verify', data)
    .then(response => response);
};

export const logout = (data: any) =>
  request
    .post('/auth/logout', data)
    .then(response => response);

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data,
  }).then(response => response.data);
